import { Stack as n, FormHelperText as i } from "@mui/material";
import { styled as o, css as r } from "./styled2.mjs";
const p = o(n)`
	flex-direction: column;
	gap: ${({ theme: t }) => t.tokens.spacing[0]};
`, s = o(i)`
	margin-inline: ${({ theme: t }) => t.spacing(1.75)};

	${({ theme: t, $hasError: e, $disabled: l }) => l ? r`
				color: ${e ? t.palette.error.main30 : t.palette.text.disabled};
			` : r`
			color: ${e ? t.palette.error.main : t.palette.text.secondary};
		`};
`;
export {
  p as StyledRoot,
  s as StyledSwitchHelperText
};
//# sourceMappingURL=styles44.mjs.map
